import { render, staticRenderFns } from "./settings-organization-data-cleaning.vue?vue&type=template&id=05747ca3&scoped=true&"
import script from "./settings-organization-data-cleaning.vue?vue&type=script&lang=js&"
export * from "./settings-organization-data-cleaning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05747ca3",
  null
  
)

export default component.exports